import JSONAPI, { Attribute, Relationship } from "@mediamonks/jsonapi-client";
import { isNumber, isString } from "isntnt";
import { Diamond } from "./Diamond";

export class RingBand extends JSONAPI.resource("ring-bands", "ring-bands")<
    RingBand
> {
    @Attribute.required(isNumber) public shopifyProductId!: string;
    @Attribute.required(isString) public name!: string | null;
    @Attribute.required(isString) public createdAt!: string | null;
    @Attribute.required(isString) public updatedAt!: string | null;
    @Relationship.toMany(() => Diamond) public diamonds!: Diamond[];
}
